var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask-mouse"},[_c('img',{attrs:{"src":require("../../assets/img/mouse.png"),"alt":""}}),_vm._v(" "),_c('p',[_vm._v("滑动查看")])])
}]

export { render, staticRenderFns }